import { HostClientType } from "@microsoft/teams-js";

/**
 * The host client type.
 * @example "web"
 * TODO: Use platform agnostic host client type.
 */
export { HostClientType };